<div class="flex flex-col justify-between py-2 custom-height">
  <!-- Menu items -->
  <div class="flex flex-col gap-4 px-[6px]">
    <div *ngFor="let groupItem of MENU_ITEMS" class="flex flex-col gap-2">
      <div
        *ngIf="groupItem.groupName"
        class="text-[#9BA9C4] text-xs uppercase font-medium px-4 h-4 whitespace-nowrap transition-opacity duration-100"
        [ngClass]="!isCollapsed ? 'opacity-100' : 'opacity-0 '"
      >
        {{ !isCollapsed ? groupItem.groupName : '' }}
      </div>

      <div class="flex flex-col gap-1">
        <div
          *ngFor="let item of groupItem.children; trackBy: trackByLabel"
          [routerLink]="item.url"
          routerLinkActive="bg-button_text_primary_color cursor-auto"
          class="flex items-center cursor-pointer h-8 font-normal rounded hover:bg-button_text_primary_color mr-[2px] relative transition-all duration-100"
          [ngClass]="!isCollapsed ? 'px-4' : 'px-[11px]'"
          [class.bg-button_text_primary_color]="isAlsoActive(item)"
          [class.cursor-auto]="isAlsoActive(item)"
          [customTooltip]="isCollapsed ? item.label : null"
        >
          <app-svg-icon
            [icon]="item.icon"
            class="text-[#fff] h-[18px] w-[18px]"
          ></app-svg-icon>
          <div
            class="text-[#fff] text-sm absolute left-11 whitespace-nowrap transition-opacity duration-100"
            [ngClass]="
              !isCollapsed ? 'opacity-100' : 'opacity-0 pointer-events-none'
            "
          >
            {{ item.label }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Profile -->
  <div
    class="border-t-[1px] border-t-[#3F4A5E] transition-all duration-100"
    [ngClass]="!isCollapsed ? 'p-2' : 'px-1 mr-1 py-3'"
  >
    <!-- Dropdown icon -->
    <div
      class="rounded-lg hover:bg-[#303D54] cursor-pointer transition-all duration-100"
      [ngClass]="!isCollapsed ? 'p-1' : 'p-0'"
      nz-dropdown
      nzTrigger="click"
      [nzDropdownMenu]="modalStatus"
      [nzPlacement]="'topCenter'"
      [(nzVisible)]="profileMenuVisible"
    >
      <!-- User data -->
      <div class="p-[6px] flex w-full justify-between items-center">
        <app-chip
          [imageUrl]="user.PictureUrl"
          [name]="user.firstName + ' ' + user.lastName"
          [email]="user.email"
          [isCollapsed]="isCollapsed"
          [tooltipPosition]="'right'"
        ></app-chip>
        <app-svg-icon
          *ngIf="!isCollapsed"
          icon="icon-vertical-dots"
          width="20"
          height="20"
        />
      </div>
    </div>

    <!-- Dropdown menu -->
    <nz-dropdown-menu #modalStatus="nzDropdownMenu">
      <div
        class="flex flex-col gap-2 items-start justify-center bg-[#35445C] rounded-lg py-2 w-[224px]"
      >
        <div
          class="px-6 py-2 flex w-full justify-between items-center border-b-[1px] border-b-[#505C71]"
        >
          <app-chip
            [imageUrl]="user.PictureUrl"
            [name]="user.firstName + ' ' + user.lastName"
            [email]="user.email"
            [tooltipPosition]="'right'"
          ></app-chip>
        </div>

        <div class="px-3 w-full flex flex-col gap-1">
          <div
            *ngFor="let item of PROFILE_ITEMS; trackBy: trackByLabel"
            [routerLink]="item.url"
            routerLinkActive="bg-[#40526E] cursor-auto"
            (click)="profileMenuVisible = false"
            class="flex gap-3 items-center cursor-pointer h-8 font-normal rounded hover:bg-[#40526E] relative transition-all duration-100 px-4 w-full"
          >
            <app-svg-icon
              [icon]="item.icon"
              class="text-[#fff] h-[18px] w-[18px]"
            ></app-svg-icon>
            <div class="text-[#fff] text-sm whitespace-nowrap">
              {{ item.label }}
            </div>
          </div>
        </div>

        <div class="border-t-[1px] border-t-[#505C71] w-full px-3 pt-2">
          <div
            (click)="auth0logout()"
            class="flex gap-3 items-center cursor-pointer h-8 font-normal rounded hover:bg-[#40526E] relative transition-all duration-100 px-4 w-full"
          >
            <app-svg-icon icon="icon-logout" class="w-5 h-5 text-[#fff]" />
            <span
              class="text-[#fff] text-sm whitespace-nowrap"
              [ngClass]="{ 'collapsed-text': isCollapsed }"
              >Logout</span
            >
          </div>
        </div>
      </div>
    </nz-dropdown-menu>
  </div>
</div>
